<ion-content>
  <div class="screen-wrapper">
    <div class="header">
      <h1>Банковские реквизиты</h1>
    </div>
    <div class="note-block">
      <div class="text">
        Укажите платежные реквизиты. Введите БИК и Расчетный счет. Это
        необходимо для полноценной работы приложения
      </div>
    </div>

    <form [formGroup]="bankingDataForm">
      <div>
        <app-base-input
          [type]="'numeric'"
          title="БИК"
          labelColor="#00BFA8"
          [placeholder]="'Введите БИК'"
          style="width: 100%"
          formControlName="bik"
          [control]="bankingDataForm.controls['bik']"
        ></app-base-input>
        <div class="error">
          <span
            *ngIf="
              bankingDataForm.get('bik')?.touched &&
              bankingDataForm.get('bik')?.invalid
            "
          >
            Введите корректный БИК (9 цифр)
          </span>
        </div>
      </div>

      <div>
        <app-base-input
          [type]="'numeric'"
          title="Расчетный счет"
          labelColor="#00BFA8"
          [placeholder]="'Введите Расчетный счет'"
          style="width: 100%"
          formControlName="rs"
          [control]="bankingDataForm.controls['rs']"
          [disabled]="!bikIsValid"
        ></app-base-input>
        <div class="error">
          <span
            *ngIf="
              !bankingDataForm.controls['rs'].errors?.['INCORRECT_RS'] &&
              bankingDataForm.get('rs')?.touched &&
              bankingDataForm.get('rs')?.invalid
              && !rsErrorDescription
            "
          >
            Введите корректный расчетный счет (20 цифр)
          </span>

          <span
            *ngIf="
              rsErrorDescription &&
              bankingDataForm.controls['rs'].errors &&
              bankingDataForm.controls['rs'].dirty
            "
          >
            {{ rsErrorDescription }}
          </span>
        </div>
      </div>
    </form>

    <div *ngIf="selectedBankData" class="displayed-banking">
      <div class="empty-data" *ngIf="!selectedBankData?.name">
        <picture>
          <source
            srcset="assets/images/banking-data.svg"
            type="image/svg+xml"
          />
          <img
            src=""
            alt="Login Background"
            fill
            priority
            width="216px"
            height="112px"
          >
        </picture>
        <div class="note">
          Здесь отобразятся реквизиты вашего банка после корректного заполнения
          БИК и Р/С
        </div>
      </div>
      <div class="bank-data" *ngIf="selectedBankData?.name">
        <div class="bank-info">
          <div class="logo-placeholder">
            <img
              *ngIf="selectedBankData.logoUrl"
              [src]="
              'assets/images/banking-information' + selectedBankData.logoUrl
            "
              alt="Логотип банка"
            />
            <img
              *ngIf="!selectedBankData.logoUrl"
              [src]="'assets/pictures/no-bank-img.svg'"
              alt="отсутствуют логотип банка"
            />
          </div>
          <div class="label">Наименование банка</div>
          <div class="value">{{ selectedBankData.name }}</div>
          <div class="label">ИНН</div>
          <div class="value">{{ selectedBankData.inn }}</div>
          <div class="label">КПП</div>
          <div class="value">{{ selectedBankData.kpp }}</div>
          <div class="label">Корреспондентский счет</div>
          <div class="value">{{ selectedBankData.ks }}</div>
        </div>
      </div>
    </div>

    <ion-button
      class="large login-text"
      mode="md"
      (click)="saveBankingData()"
      [disabled]="bankingDataForm.invalid || !bikIsValid || !rsIsValid"
    >
      Сохранить реквизиты
    </ion-button>
    <ion-button
      *ngIf="!this.loginFlag"
      class="large light"
      mode="md"
      (click)="close()"
    >
      <span> Закрыть </span>
    </ion-button>
  </div>
</ion-content>
